import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-form-footer-end',
  styles: [
    ':host { margin-left: auto}'
  ],
  template: '<ng-content />'
})
export class FormFooterEndComponent {}
